{
	"brand": {
		"tab_title": "{{productName}} · Backoffice",
		"tab_title_unbranded": "Backoffice"
	},
	"login": {
		"failed": "Sign-in could not be completed. Try again.",
		"redirecting": "Redirecting to sign-in…",
		"request_id": "Request id: {{requestId}}",
		"retry": "Try again"
	}
}
